/**
 * Обработчик ошибок
 */
export default class ErrorHandler {
	/**
	 * Инициализировать парсер
	 * @param {Object} config
	 */
	constructor(config) {
		this.config = config || {}
	}

	/**
	 * Разделитель сообщений об ошибках
	 */
	get separator() {
		return this.config.separator || "; "
	}

	/**
	 * Обраболтать ошибку
	 * @param {Object} error
	 * @param {String} defaultMessage
	 * @param {String} separator
	 */
	handle(error) {
		return {
			/**
			 * Парсить сообщения
			 * @param {String} defaultMessage
			 * @param {String} separator
			 */
			parse: (defaultMessage, separator) => {
				const message = this.parse(error, defaultMessage, separator)

				return message
			},

			/**
			 * Парсить сообщения об ошибках для формы
			 * @param {String} defaultMessage
			 * @param {String} separator
			 */
			parseForm: (defaultMessage, separator) => {
				const message = this.parseForm(error, defaultMessage, separator)

				return message
			}
		}
	}

	/**
	 * Парсить сообщения
	 * @param {Object} error
	 * @param {String} defaultMessage
	 * @param {String} separator
	 * @return {String}
	 */
	parse(error, defaultMessage, separator) {
		separator = separator || this.separator

		if (!error || !error.data) {
			return defaultMessage || "Ошибка"
		}

		// Сообщения об ошибках
		const messages = []

		// Обойти все поля с ошибками
		for (const message of Object.values(error.data)) {
			// Если сообщение представляет из себя коллекцию сообщений
			if (Array.isArray(message)) {
				message.forEach(value => messages.push(value))
			} else {
				messages.push(message)
			}
		}

		return messages.join(separator)
	}

	/**
	 * Парсить сообщения об ошибках для формы
	 * @param {Object} error
	 * @param {String} defaultMessage
	 * @return {Object}
	 */
	parseForm(error, message) {
		let fields = []
		let errors = {}

		if (error && error.data) {
			fields = Object.keys(error.data)

			for (const [field, messages] of Object.entries(error.data)) {
				errors[field] = messages[0] || "Поле заполнено неверно"
			}
		}

		return { fields, errors, message }
	}
}
